export const isPreviewEnvironment = () =>
    process.env.VERCEL_ENV === 'preview' ||
    process.env.NEXT_PUBLIC_VERCEL_ENV === 'preview' ||
    process.env.VERCEL_ENV === 'staging' ||
    process.env.NEXT_PUBLIC_VERCEL_ENV === 'staging';

export const isProductionEnvironment = () =>
    process.env.VERCEL_ENV === 'production' || process.env.NEXT_PUBLIC_VERCEL_ENV === 'production';

export const isLocalEnvironment = () => !isPreviewEnvironment() && !isProductionEnvironment();

const CineamoTestDomain = 'cineamomoviehouse';
const WeischerAdTestDomain = 'ad-test';
const demoDomains = [CineamoTestDomain, WeischerAdTestDomain];

export function checkIsWeischerAdTestDomain(domain?: string): boolean {
    return !!domain?.includes(WeischerAdTestDomain);
}

export function checkIsDemoDomain(domain: string): boolean {
    return demoDomains.some((demoDomain) => domain.includes(demoDomain));
}
